// import { HTML5Backend } from "react-dnd-html5-backend";
// import { DndProvider } from "react-dnd";
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import "./prototypes";
// import "./services/pushNotification.js";

import { Provider } from "react-redux";
// import { PersistorStore, Store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import PageRoutes from "./routes";
import { PersistorStore, Store } from "./redux/store";
import { ToastContainer } from "react-toastify";
// import Notification from "./services/notification";
import "react-circular-progressbar/dist/styles.css";

function App() {
  const _env = process.env.REACT_APP__ENV_IS;
  const handleContextMenu = (e: any) => {
    if (_env !== "dev") e.preventDefault();
  };
  return (
    <Provider store={Store}>
      <PersistGate loading={null} persistor={PersistorStore}>
        {/* <DndProvider backend={HTML5Backend}> */}
        <div onContextMenu={handleContextMenu} className="App">
          <ToastContainer autoClose={3000} />
          {/* <Notification /> */}
          <PageRoutes />
        </div>
        {/* </DndProvider> */}
      </PersistGate>
    </Provider>
  );
}

export default App;
